<ng-template #blockUITemplate>
  <div class="custom-block-ui">
    <div class="spinner"></div>
    <p>Please wait...</p>
  </div>
</ng-template>

<div *blockUI="blockUIName; template: blockUITemplate">
  <ng-content></ng-content>
</div>